import api from './client';

export async function login(email: string, password: string) {
  const res = await api.post('/auth/login', { email, password });
  return res.data;
}

/**
 * Request a custom Firebase token for impersonating another user.
 * Returns the token string.
 */
export const loginAs = async (uid: string): Promise<string> => {
  const { data } = await api.post('/auth/login_as', { uid });
  return data.token;
};
